import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

// create slice
const name = "superAdminDashboard";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const superAdminDashboardActions = { ...slice.actions, ...extraActions };
export const superAdminDashboardReducer = slice.reducer;

function createInitialState() {
  return {
    cardCountsVisibleToSuperAdmin: {},
    loginStatusVisibleToSuperAdmin: {},
    membersCountVisibleToSuperAdmin: {},
    eventsCountVisibleToSuperAdmin: {},
    committeeMembershipVisibleToSuperAdmin: {},
    exportSuperAdminEventData:{},
    exportSuperAdminMembersCountData:{},
    exportSuperAdminLoginStatus:{},
    loading: false,
  };
}

function createReducers() {
  return {
    // updateSuperAdminVisibleForm,
    // resetSuperAdminVisibleForm,
  };
}

// function updateSuperAdminVisibleForm(state, action) {
//   state.superAdminVisibleForm = action?.payload;
// }

// function resetSuperAdminVisibleForm(state, action) {
//   state.superAdminVisibleForm = superAdminVisibleForm;
// }

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getSuperAdminDashboardCardCount: getSuperAdminDashboardCardCount(),
    getloginStatusVisibleToSuperAdmin: getloginStatusVisibleToSuperAdmin(), //Super Admin Visible Login Status
    getMembersCountbyEachCommittee: getMembersCountbyEachCommittee(),
    getEventCountByCommittee: getEventCountByCommittee(),
    getCommitteeMembershipPercentage: getCommitteeMembershipPercentage(),
    exportSuperAdminEventData: exportSuperAdminEventData(),
    exportSuperAdminMembersCountData: exportSuperAdminMembersCountData(),
    exportSuperAdminLoginStatus: exportSuperAdminLoginStatus(),
  };

  /* get all Super Admin Visible Counts (Members, Events, Category, Documents) */
  function getSuperAdminDashboardCardCount() {
    return createAsyncThunk(
      `${name}/getSuperAdminDashboardCardCount`,
      async ({startDate, endDate }) => {
        return await fetchWrapper.get(
          `${baseUrl}/dashboard/getSuperAdminDashboardCardCount?startDate=${startDate}&endDate=${endDate}`
        );
      }
    );
  }

  //Super Admin Visible Login Status
  function getloginStatusVisibleToSuperAdmin() {
    return createAsyncThunk(`${name}/getLoginStatusforSuperAdmin`, async ({startDate, endDate }) => {
      return await fetchWrapper.get(
        `${baseUrl}/dashboard/login-stats?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }

  // get Members count by each committee
  function getMembersCountbyEachCommittee() {
    return createAsyncThunk(`${name}/user-count-by-committee`, async ({startDate, endDate }) => {
      return await fetchWrapper.get(
        `${baseUrl}/dashboard/user-count-by-committee?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }

  // get Members count by each committee
  function getEventCountByCommittee() {
    return createAsyncThunk(`${name}/event-count-by-committee`, async ({startDate, endDate }) => {
      return await fetchWrapper.get(
        `${baseUrl}/dashboard/event-count-by-committee?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }

  // get Members count by each committee
  function getCommitteeMembershipPercentage() {
    return createAsyncThunk(
      `${name}/committee-membership-percentage`,
      async ({startDate, endDate }) => {
        return await fetchWrapper.get(
          `${baseUrl}/dashboard/committee-membership-percentage?startDate=${startDate}&endDate=${endDate}`
        );
      }
    );
  }


  // Used for export Super Admin events to excel
  function exportSuperAdminEventData() {
    return createAsyncThunk(`${name}/super-admin-events`, async ({startDate, endDate }) => {
      return await fetchWrapper.get(
         `${baseUrl}/export/super-admin-events?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }

  // Used for export specific committee events to excel
  function exportSuperAdminMembersCountData() {
    return createAsyncThunk(`${name}/super-admin-users`, async ({ startDate, endDate }) => {
      return await fetchWrapper.get(
         `${baseUrl}/export/super-admin-users?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }

   // Used for export specific committee events to excel
  function exportSuperAdminLoginStatus() {
    return createAsyncThunk(`${name}/super-admin-login-history`, async ({ startDate, endDate }) => {
      return await fetchWrapper.get(
         `${baseUrl}/export/super-admin-login-history?startDate=${startDate}&endDate=${endDate}`
      );
    });
  }
}

 

function createExtraReducers(builder) {
  builder
    //Super Admin Visible Card Counts
    .addCase(extraActions.getSuperAdminDashboardCardCount.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getSuperAdminDashboardCardCount.fulfilled,
      (state, action) => {
        state.loading = false;
        state.cardCountsVisibleToSuperAdmin = action?.payload;
      }
    )
    .addCase(
      extraActions.getSuperAdminDashboardCardCount.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //Super Admin Visible Login Status
    .addCase(
      extraActions.getloginStatusVisibleToSuperAdmin.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.getloginStatusVisibleToSuperAdmin.fulfilled,
      (state, action) => {
        state.loading = false;
        state.loginStatusVisibleToSuperAdmin = action?.payload;
      }
    )
    .addCase(
      extraActions.getloginStatusVisibleToSuperAdmin.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //Users Count By Committee
    .addCase(extraActions.getMembersCountbyEachCommittee.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getMembersCountbyEachCommittee.fulfilled,
      (state, action) => {
        state.loading = false;
        state.membersCountVisibleToSuperAdmin = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.getMembersCountbyEachCommittee.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //Event Count By Committee
    .addCase(extraActions.getEventCountByCommittee.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getEventCountByCommittee.fulfilled,
      (state, action) => {
        state.loading = false;
        state.eventsCountVisibleToSuperAdmin = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.getEventCountByCommittee.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //Membership Percentage
    .addCase(extraActions.getCommitteeMembershipPercentage.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getCommitteeMembershipPercentage.fulfilled,
      (state, action) => {
        state.loading = false;
        state.committeeMembershipVisibleToSuperAdmin = action?.payload;
      }
    )
    .addCase(
      extraActions.getCommitteeMembershipPercentage.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    // Used for export specific committee events to excel
    .addCase(extraActions.exportSuperAdminEventData.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.exportSuperAdminEventData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.exportSuperAdminEventData = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.exportSuperAdminEventData.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    // Used for export specific committee events to excel
    .addCase(extraActions.exportSuperAdminMembersCountData.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.exportSuperAdminMembersCountData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.exportSuperAdminMembersCountData = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.exportSuperAdminMembersCountData.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    // Used for export specific committee events to excel
    .addCase(extraActions.exportSuperAdminLoginStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.exportSuperAdminLoginStatus.fulfilled,
      (state, action) => {
        state.loading = false;
        state.exportSuperAdminLoginStatus = action?.payload?.data;
      }
    )
    .addCase(
      extraActions.exportSuperAdminLoginStatus.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    );
}
